import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Composant pour gérer la redirection depuis la racine "/"
const RootRedirect = () => {
  const { isAuthenticated, currentUser, loading, isSuperAdmin, isAdmin, isStudent, isCompany, isCommercial } = useAuth();
  
  // Afficher un indicateur de chargement pendant la vérification de l'authentification
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Chargement...
      </div>
    );
  }
  
  // Si l'utilisateur n'est pas authentifié, rediriger vers la page de connexion
  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }
  
  // Si l'utilisateur est authentifié, vérifier s'il s'agit de sa première connexion
  if (currentUser && currentUser.first_connexion === true) {
    if (isStudent) {
      return <Navigate to="/complete-account" replace />;
    } else if (isCompany) {
      return <Navigate to="/account/complete-account" replace />;
    } else if (isAdmin) {
      return <Navigate to="/partner/complete-account" replace />;
    }
    return <Navigate to="/complete-account" replace />;
  }
  
  // Rediriger selon le rôle de l'utilisateur
  if (isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  } else if (isAdmin) {
    return <Navigate to="/admin/dashboard" replace />;
  } else if (isStudent) {
    return <Navigate to="/student/dashboard" replace />;
  } else if (isCompany) {
    return <Navigate to="/company/dashboard" replace />;
  } else if (isCommercial) {
  return <Navigate to="/commercial/prospects_student" replace />;
}
  
  // Redirection par défaut vers la page de connexion
  return <Navigate to="/sign-in" replace />;
};

export default RootRedirect;
